import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    margin: '0px 0px 16px 0px',
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
      display: 'flex',
      alignItems: 'center',
    },

    '& .MuiFormControlLabel-label.Mui-disabled': {
      color: theme.color.greys[80],
    },
  },

  label: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    }
  },
}), { name: 'FormControlLabel' });
